module.exports = __webpack_public_path__ + "static/city3-e39d2fb3dcc2a33031182aad919e888d.svg";